import { render } from "./CardRegistro.vue?vue&type=template&id=f0c70a74&scoped=true"
import script from "./CardRegistro.vue?vue&type=script&lang=js"
export * from "./CardRegistro.vue?vue&type=script&lang=js"

import "./CardRegistro.vue?vue&type=style&index=0&id=f0c70a74&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0c70a74"]])

export default __exports__